import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@radix-ui/react-dropdown-menu';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MenuBtn from '../../../../../assets/Humburger-btn.svg';
import Calendar from '../../../../../assets/mobile-navbar/Calendar2.svg';
import HomeIcon from '../../../../../assets/mobile-navbar/HomeIcon.svg';
import MessageIcon from '../../../../../assets/mobile-navbar/Message_Icon.svg';
import RequestIcon from '../../../../../assets/mobile-navbar/RequestIconMobile.svg';
import SettingsIcon from '../../../../../assets/mobile-navbar/Setting_Icon.svg';
import UserIcon from '../../../../../assets/mobile-navbar/User_icon.svg';
import { loadMyProfileAsClient } from '../../../../../core/usecases/client-user-profile/loadMyProfileAsClient';
import { navigateToClientSettingsAction } from '../../../../../core/usecases/client-user-profile/navigateToClientSettingsAction';
import { navigateToClientBookedAppointmentsScreenAction } from '../../../../../core/usecases/shared/navigateToClientBookedAppointmentsScreenAction';
import { navigateToClientDashboardAction } from '../../../../../core/usecases/shared/navigateToClientDashboardAction';
import { navigateToMyHealersScreenAction } from '../../../../../core/usecases/shared/navigateToMyHealersScreenAction';
import { navigateToRequestNewHealerAction } from '../../../../../core/usecases/shared/navigateToRequestNewHealerAction';
import { NavigationOption } from '../../../../../store/reducers/global.reducer';
import { selectAvailableNavigationOptionsForClient, selectCurrentUser } from '../../../../../store/selectors/global.selector';
import { navigateToMySelectionsAction } from '../../../../../core/usecases/shared/navigateToMySelectionsAction';
import MySelections from '@assets/navbar/MySelections.svg?react';

const ClientSandwichMenu = () => {
  const clientUserProfile = useSelector(selectCurrentUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const availableNavigationOptions: NavigationOption[] = useSelector(selectAvailableNavigationOptionsForClient);

  useEffect(() => {
    if (clientUserProfile?.id) {
      dispatch<any>(loadMyProfileAsClient(clientUserProfile.id));
    }
  }, [clientUserProfile?.id]);

  const handleRequestNewHealerClicked = () => {
    dispatch<any>(navigateToRequestNewHealerAction(navigate, clientUserProfile?.id));
  };

  const handleRequestMySelections = () => {
    if (clientUserProfile?.id) {
      dispatch<any>(navigateToMySelectionsAction(navigate, clientUserProfile.id));
    }
  };

  const handleHomeClicked = () => {
    if (clientUserProfile?.id) {
      dispatch<any>(navigateToClientDashboardAction(navigate, clientUserProfile.id));
    }
  };

  const handleSettingsClicked = () => {
    if (clientUserProfile?.id) {
      dispatch<any>(navigateToClientSettingsAction(navigate, clientUserProfile?.id));
    }
  };

  const handleBookedAppointmentsClicked = () => {
    if (clientUserProfile?.id) {
      dispatch<any>(navigateToClientBookedAppointmentsScreenAction(navigate, clientUserProfile?.id));
    }
  };

  const handleMyHealersClicked = () => {
    if (clientUserProfile?.id) {
      dispatch<any>(navigateToMyHealersScreenAction(navigate, clientUserProfile?.id));
    }
  };

  const handleContactUsClicked = () => {
    window.open('mailto:contact@luminara.care');
  };

  return (
    <div className="z-50 ">
      {availableNavigationOptions.length > 0 && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild className="py-3">
            <button className="focus:outline-none">
              <img src={MenuBtn} alt="" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-72 h-screen px-4 py-6 bg-white">
            <DropdownMenuItem className="py-2">
              <p className="font-Sweet text-H3 text-primary">{`Welcome, ${clientUserProfile?.firstName}!`}</p>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              {availableNavigationOptions.includes('HOME') && (
                <DropdownMenuItem onClick={handleHomeClicked}>
                  <div className="flex gap-3 py-3 items-center">
                    <img src={HomeIcon} alt="" />
                    <p className="text-Body1 font-Sweet text-primary">Home</p>
                  </div>
                </DropdownMenuItem>
              )}

              {availableNavigationOptions.includes('BOOKED_APPOINTMENTS') && (
                <DropdownMenuItem onClick={handleBookedAppointmentsClicked}>
                  <div className="flex gap-3 py-3 items-center">
                    <img src={Calendar} alt="" />
                    <p className="text-Body1 font-Sweet text-primary">Booked appointments</p>
                  </div>
                </DropdownMenuItem>
              )}

              {availableNavigationOptions.includes('MY_HEALERS') && (
                <DropdownMenuItem onClick={handleMyHealersClicked}>
                  <div className="flex gap-3 py-3 items-center">
                    <img src={UserIcon} alt="" />
                    <p className="text-Body1 font-Sweet text-primary">Healers</p>
                  </div>
                </DropdownMenuItem>
              )}

              {availableNavigationOptions.includes('SETTINGS') && (
                <DropdownMenuItem onClick={handleSettingsClicked}>
                  <div className="flex gap-3 py-3 items-center">
                    <img src={SettingsIcon} alt="" />
                    <p className="text-Body1 font-Sweet text-primary">Settings</p>
                  </div>
                </DropdownMenuItem>
              )}

              {availableNavigationOptions.includes('CONTACT_US') && (
                <DropdownMenuItem onClick={handleContactUsClicked}>
                  <div className="flex gap-3 py-3 items-center">
                    <img src={MessageIcon} alt="" />
                    <p className="text-Body1 font-Sweet text-primary">Contact us</p>
                  </div>
                </DropdownMenuItem>
              )}

              {availableNavigationOptions.includes('REQUEST_NEW_HEALER') && (
                <DropdownMenuItem onClick={handleRequestNewHealerClicked}>
                  <div className="flex gap-3 py-3 items-center">
                    <img src={RequestIcon} alt="" />
                    <p className="text-Body1 font-Sweet text-primary">Request new healer</p>
                  </div>
                </DropdownMenuItem>
              )}
              {availableNavigationOptions.includes('MY_SELECTIONS') && (
                <DropdownMenuItem onClick={handleRequestMySelections}>
                  <div className="flex gap-3 py-3 items-center">
                    <MySelections className={`w-[28px] h-[28px] `} />
                    <p className="text-Body1 font-Sweet text-primary">My selections</p>
                  </div>
                </DropdownMenuItem>
              )}
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
};

export default ClientSandwichMenu;
